module.exports = __webpack_public_path__ + "static/media/car-side.3ad189a5.svg";